import { message } from 'antd'
import clsx from 'clsx'
import { useFormik } from 'formik'
import React, { useEffect, useState, ChangeEvent, KeyboardEvent } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import * as Yup from 'yup'
import httpService from '../../setup/http/httpServices'
import { RootState } from '../../setup/redux/RootReducer'
import { toAbsoluteUrl } from '../../_metronic/helpers'
import { Alerts } from '../modules/alerts/Alerts'
import { IUserModel } from '../modules/auth/models/UserModel'
import './basic.css'
import { ImageCropper } from './ImageCropper'
import { MasterTable } from './MasterTable'
import { handleFileUpload } from '../../setup/Upload/Upload'

interface ChipProps {
  label: string;
  onRemove: () => void;
}

const Chip: React.FC<ChipProps> = ({ label, onRemove }) => {
  return (
    <div className='d-flex align-items-center justify-content-around border px-3 py-2 m-2 rounded-pill'>
      {label}
      <img
        style={{ paddingLeft: '5px', cursor: 'pointer', display: 'inline' }}
        onClick={onRemove}
        src={toAbsoluteUrl('/media/icons/Custom/Cross.svg')}
        alt='cross'
      />
    </div>
  );
};


var initialValues = {
  elemName: '',
  phrases: [],
  // categoryIconUrl: 'test.png',
  // iqDataCategoryId: '',
}
const categorySchema = Yup.object().shape({
  elemName: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Name is required')
    .matches(/^(?=.*[A-Za-z]).{3,50}$/, 'Should not contain just numbers'),
  // phrases: Yup.array()
  //   .min(2, 'Select at least 2 phrases')
  //   .required('Phrases is required'),

  // iqDataCategoryId: Yup.string().required('IQ Data Id is required'),
})
export function MasterPage(props: any) {
  const user: IUserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as IUserModel
  // const access = user.permissions.masters[1] || user.permissions.admin

  // const [bgImage, setBgImage] = useState(toAbsoluteUrl('/media/logos/categoryIcon.png'))
  const [isSuccess, setIsSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  // const [toggleCrop, setToggleCrop] = useState(false)
  const [isFailure, setIsFailure] = useState(false)
  const [state, setState] = useState("")
  const [final, setFinal] = useState("")
  const [name, setName] = useState("")
  const [update, setUpdate] = useState(false)
  const [id, setId] = useState()
  const [refetch, setRefetch] = useState(true)
  const [logo, setLogo] = useState('')
  const [inputValue, setInputValue] = useState<string>('');
  const [phrases, setPhrases] = useState<string[]>([]);
  const [LogoLoading, setLogoLoading] = useState(false)

  console.log("phrases", phrases)
  console.log("name", name)


  // const [categoryId, setCategoryId] = useState(null)
  const [responseMessage, setResponseMessage] = useState('')
  // const [selectedFile, setSelectedFile] = useState(new File([], ''))
  const key = 'updatable'
  const hideAlerts = () => {
    setIsSuccess(false)
    setIsFailure(false)
  }

  console.log('state', state);
  console.log('final', final);


  const history = useHistory()
  useEffect(() => {
    setUpdate(false)
    const text = history.location.state["type"]
    const result = text.replace(/([A-Z])/g, " $1");
    const finalResult = result.charAt(0).toUpperCase() + result.slice(1);
    setFinal(finalResult)
    console.log(history.location.pathname.split("-")[1], history.location.state['type'], finalResult);
    setState(history.location.pathname.split("-")[1])
    console.log('type', history.location.pathname.split("-")[1]);

    setName(history.location.pathname.split("-")[history.location.pathname.split("-").length - 1])
  }, [history.location.pathname]);

  
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: categorySchema,
    enableReinitialize: true,
    onSubmit: (values, { setStatus, setSubmitting }) => {

      //   console.log("here",update);
      setIsLoading(true)
      setIsFailure(false)
      setIsSuccess(false)
      let fd = new FormData()
      fd.append('elemName', values.elemName)



      // fd.append('iqDataCategoryId', values.iqDataCategoryId)
      // fd.append('categoryIconUrl', selectedFile)
      console.log(values.elemName);
      console.log("update", update)

      const hide = message.loading({ content: 'Loading...', key })

      if (update) {
        httpService.patchData(
          '/' + (history.location.state['type'] == "blogCategory" ? 'blogCategory' : (state + '-master')),
          {
            Name: values.elemName,
            AssociatedPhrases: values?.phrases,
            logo: logo,
            Id: id
          },
          (res) => {
            console.log(res);
            setIsLoading(false)
            setRefetch(prev => !prev)
            setUpdate(false)
            formik.resetForm()
            setPhrases([])
            setLogo('')
          },
          (err) => {
            console.log(err);
            message.error(err?.message || "Something went wrong");
            setIsLoading(false)
            setUpdate(false)
            setPhrases([])
            setLogo('')
            formik.resetForm()
          }
        )

      }
      else {
        httpService.postData(
          '/' + (history.location.state['type'] == "blogCategory" ? 'blogCategory' : (state + '-master')),
          {
            Name: values.elemName,
            AssociatedPhrases: values?.phrases,
            logo: logo
          },
          (res) => {
            console.log(res);
            setIsLoading(false)
            setRefetch(prev => !prev)
            setLogo('')
            setPhrases([])
            formik.resetForm()

          },
          (err) => {
            console.log(err);
            message.error(err.message);
            setIsLoading(false)


          }
        )
      }

      // if (categoryId) {
      //   httpService.patchData(
      //     '/category-master/' + categoryId,
      //     fd,
      //     (res: any) => {
      //       formik.resetForm()
      //       setIsFailure(false)
      //       setResponseMessage('Success! Category updated.')
      //       setCategoryId(null)
      //       setIsSuccess(true)
      //       setBgImage(toAbsoluteUrl('/media/logos/categoryIcon.png'))
      //       setTimeout(hide, 500)
      //       setTimeout(hideAlerts, 4000)
      //       resetImage()
      //     },
      //     (err: any) => {
      //       hide()
      //       setIsSuccess(false)
      //       setIsFailure(true)
      //       setResponseMessage(err.message)
      //       setTimeout(hideAlerts, 4000)
      //     }
      //   )
      // } else if (selectedFile.size > 0)
      //   httpService.postData(
      //     '/category-master',
      //     fd,
      //     (res: any) => {
      //       formik.resetForm()
      //       setIsFailure(false)
      //       setResponseMessage('Success! Category added.')
      //       setCategoryId(null)
      //       setIsSuccess(true)
      //       setBgImage(toAbsoluteUrl('/media/logos/categoryIcon.png'))
      //       setTimeout(hide, 500)
      //       setTimeout(hideAlerts, 4000)
      //       resetImage()
      //     },
      //     (err: any) => {
      //       hide()
      //       setIsSuccess(false)
      //       setIsFailure(true)
      //       setResponseMessage(err.message)
      //       setTimeout(hideAlerts, 4000)
      //     }
      //   )
      // else if (selectedFile.size === 0) {
      //   formik.setFieldError('categoryIconUrl', 'Please select category icon.')
      // }
    },
  })

  // const onChangeLogo = async (event: any) => {
  //   const d = await handleFileUpload(event, 180, 180);
  //   console.log(d);
  //   setLogo(d ? d : '')
  // }

  const onChangeLogo = async (event: any) => {
    let logoValue = '';

    if (state === 'components') {
      const d2 = await handleFileUpload(event, 220, 124, setLogoLoading);
      logoValue = d2 ? d2 : '';
    } else {
      const d = await handleFileUpload(event, 180, 180, setLogoLoading);
      logoValue = d ? d : '';
    }

    setLogo(logoValue);
  }

  // function onChange(event: any) {
  //   let file = event.target.files[0]
  //   setSelectedFile(file)
  //   var reader = new FileReader()
  //   reader.readAsDataURL(file)
  //   reader.onload = function () {
  //     setBgImage('' + reader.result + '')
  //     setToggleCrop(true)
  //   }
  // }

  // function resetImage() {
  //   setSelectedFile(new File([], ''))
  //   setBgImage(toAbsoluteUrl('/media/logos/categoryIcon.png'))
  // }

  // const handleCategory = (id: any) => {
  //   httpService.getData(
  //     '/category-master/' + id,
  //     (res: any) => {
  //       formik.setValues(res.data.data.category)
  //       setBgImage(toAbsoluteUrl(res.data.data.category.avatar))
  //       setCategoryId(id)
  //     },
  //     (error: any) => {
  //       message.error(error.message)
  //     }
  //   )
  // }

  // async function handleCrop(image: any) {
  //   setBgImage(image)
  //   const response = await fetch(image, { mode: 'no-cors' })
  //   const data = await response.blob()
  //   setSelectedFile(
  //     new File([data], selectedFile?.name, {
  //       type: selectedFile.type,
  //     })
  //   )
  //   formik.setErrors({})
  //   setToggleCrop(false)
  // }

  // const handleCancel = () => {
  //   setSelectedFile(new File([], ''))
  //   setBgImage(toAbsoluteUrl('/media/logos/categoryIcon.png'))
  //   setToggleCrop(false)
  // }

  useEffect(() => {
    formik.resetForm()
  }, [state, final])





  //  Associated Phrases chips function
  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
    // formik.handleChange(e);
  };

  const addChip = () => {
    if (inputValue.trim() !== '') {
      const updatedPhrases = [...phrases, inputValue?.trim()];
      setPhrases(updatedPhrases);
      setInputValue('');
      formik.setFieldValue('phrases', updatedPhrases);
    }
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' || e.key === ',') {
      e.preventDefault();
      addChip();
      // formik.handleChange(e);
    }
  };

  const handleRemoveChip = (chipIndex: number) => {
    setPhrases((prevChips) => {
      const updatedPhrases = prevChips.filter((_, index) => index !== chipIndex);
      formik.setFieldValue('phrases', updatedPhrases);
      return updatedPhrases;
    });
  };



  console.log('name', name)


  return (
    <div className='d-flex justify-content-center'>
      <div className='addCategory'>
        <h3 className='mb-0'>{update ? "Update" : "Add New"} {name.charAt(0).toUpperCase() + name.slice(1)}</h3>
        {/* <p className='fs-7 text-gray-400'>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit.{' '}
        </p> */}
        <Alerts
          visible={isSuccess}
          type='success'
          message={responseMessage}
          description={'Description'}
        ></Alerts>
        <Alerts
          visible={isFailure}
          type='error'
          message={responseMessage}
          description={'Description'}
        ></Alerts>
        <form noValidate id='kt_login_signup_form' onSubmit={formik.handleSubmit}>
          <div>
            <h6 className='fw-bold required m32'>{name.charAt(0).toUpperCase() + name.slice(1)} Name</h6>
            <input
              {...formik.getFieldProps('elemName')}
              type='text'
              className={clsx(
                'form-control form-control-solid rounded-4 border-0 bg-gray-100',
                {
                  'is-invalid': formik.touched.elemName && formik.errors.elemName,
                },
                {
                  'is-valid': formik.touched.elemName && !formik.errors.elemName,
                }
              )}
            />

            {formik.touched.elemName && formik.errors.elemName && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span className='text-danger' role='alert'>
                    {formik.errors.elemName}
                  </span>
                </div>
              </div>
            )}
          </div>

          {['pages', 'components', 'category'].includes(state) &&
            <div>
              <h6 className='fw-bold required m32'>Associated Phrases</h6>
              <p className=''>Enter comma separated values</p>
              <div className="input-phrases-box bg-gray-100">
                {phrases?.map((chip, index) => (
                  <Chip key={index} label={chip} onRemove={() => handleRemoveChip(index)} />
                ))}
                <input
                  {...formik.getFieldProps('phrases')}
                  className={clsx(
                    'form-control form-control-solid rounded-4 border-0 bg-gray-100',
                    {
                      'is-invalid': formik.touched.phrases && formik.errors.phrases,
                    },
                    {
                      'is-valid': formik.touched.phrases && !formik.errors.phrases,
                    }
                  )}
                  type="text"
                  value={inputValue}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                />
              </div>

              {formik.touched.phrases && formik.errors.phrases && (
                <div className='fv-plugins-message-container'>
                  <div className='fv-help-block'>
                    <span className='text-danger' role='alert'>
                      {formik.errors.phrases}
                    </span>
                  </div>
                </div>
              )}
            </div>
          }

          {
            (state === 'framework' || state === 'components') &&
            <div>
              <div className=''>
                <div className='mt-2'>
                  <h6 className='fw-bold required m32 required'>Logo</h6>
                  <p className='fw-normal' style={{ fontSize: '12px' }}>Logo Size: {state === 'components' ? "220 x 124" : "180 x 180"}</p>
                  {/* <p className='text-gray-500'>
                    {!fetchedMob && 'Click next to fetch screenshot'}
                    {loadingMob && 'Fetching screenshot ...'}
                    {fetchedMob &&
                      !loadingMob &&
                      !mobfetchErr &&
                      !manualMob &&
                      'Fetched Screenshot'}
                    {mobfetchErr && 'Fetching Failed!'}
                    {manualMob && 'Manually Uploaded'}
                  </p> */}
                </div>
                <div className='d-flex align-items-center justify-content-between'>
                  <button
                    type='button'
                    className={
                      !logo
                        ? 'btn btn-gray-200 screenshotComponentBtn border border-gray-500'
                        : 'screenshotComponentBtn'
                    }
                    onClick={() => {
                      // window.open(process.env.REACT_APP_API_URL.split("/api/v1")[0]+mobURL, "_blank");
                      window.open(logo, '_blank')
                    }}
                    disabled={!logo}
                  >
                    {/* {logo && (
                      <img src={toAbsoluteUrl('/media/icons/Custom/eye.svg')} alt='eye' />
                    )} */}
                    &nbsp; Preview
                  </button>
                  <button
                    type='button'
                    className='btn btn-gray-200 screenshotComponentBtn border border-gray-500 w-200px mx-4'
                    onClick={() => {
                      document.getElementById('frame_logo').click()
                    }}
                  >
                    {LogoLoading ? "Uploading..." : logo ? 'Re-Uplaod' : 'Upload'}
                  </button>
                  <input
                    type='file'
                    accept='.png, .jpg, .jpeg, .svg, .webp'
                    style={{ display: 'none' }}
                    id={'frame_logo'}
                    onChange={onChangeLogo}
                  />
                </div>
              </div>

            </div>
          }

          <div className='m16 w-100 flex flex-wrap'>

            <button
              type='submit'
              disabled={!formik.isValid || isLoading}
              className='btn btn-primary fs-6 categoryButton '
            >
              {update ? "Update" : "Add"} {name.charAt(0).toUpperCase() + name.slice(1)}
            </button>
            <button
              type='button'
              onClick={() => {
                formik.resetForm()
                setUpdate(false)
                setPhrases([])
              }}
              className='btn fw-bolder btn-white fs-6 categoryButton '
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
      {state !== "" && <MasterTable
        // editCategory={handleCategory}
        updatable={isSuccess || isFailure}
        access={true}
        type={state}
        final={final}
        formik={formik}
        setUpdate={setUpdate}
        setId={setId}
        refetch={refetch}
        setLogo={setLogo}
        setPhrases={setPhrases}
        setRefetch={setRefetch}
      ></MasterTable>}
      {/* {toggleCrop && <ImageCropper cancel={handleCancel} editImage={handleCrop} image={bgImage} />} */}
    </div>
  )
}
